import { RouteObject } from "react-router-dom";
import AddIncident from "./components/create/create";
import { Landing } from "./components/dashboard/landing";
import IncidentDetail from "./components/detail/detail";
export interface IncidentRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: IncidentRoute[];
}
export const axIncidentRoutes: IncidentRoute[] = [
  {
    path: "ax/field-alerts/incidents",
    element: <Landing />,
  },
  {
    path: "ax/field-alerts/incidents/view/:id",
    element: <IncidentDetail />,
  },
  {
    path: "ax/field-alerts/incidents/create",
    element: <AddIncident />,
  },
  {
    path: "ax/field-alerts/incidents/create/:action/:id",
    element: <AddIncident />,
  },
];
